import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';
import { DecodedItsoMessageService } from 'src/app/angularJS/services/decoded-itso-message/decoded-itso-message.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A controller that contains properties and methods related to manipulating decoded itso messages that have been imported into the client
 */
export class DecodedItsoMessageUploadListController {
  public static $inject = [
    'ACTToolbarService',
    'dialogService',
    'decodedItsoMessageService',
    '$q',
    'UserMessages',
    'userService',
    '$stateParams',
    '$rootScope',
    'breadcrumbService',
    '$translate'
  ];

  public showMoreFieldS = false;
  public decodedItsoMessages: Array<InterACT.Interfaces.ItsoMessages.DecodedItsoMessage> = [];
  public pagedDecodedItsoMessages: Array<InterACT.Interfaces.ItsoMessages.DecodedItsoMessage> = [];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    perPageCount: 15,
    totalCount: 0,
    currentPage: 1
  };

  constructor(
    private ActToolbarService: ACTToolbarService,
    private dialogService: DialogService,
    private decodedItsoMessageService: DecodedItsoMessageService,
    private $q: ng.IQService,
    private UserMessages: UserMessagesService,
    private userService: UserService,
    $stateParams: any,
    private $rootScope,
    private breadcrumbService: BreadcrumbService,
    private $translate: ng.translate.ITranslateService
  ) {
    this.breadcrumbService.setBreadcrumbs([{
      name: 'ITSO_MESSAGE_UPLOAD.ITSO_MESSAGE_UPLOAD',
      sref: 'decoded-itso-message-upload'
    }, {
      name: 'ITSO_MESSAGE_UPLOAD.CREATE_MESSAGES',
      sref: 'decoded-itso-message-list'
    }]);

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('ITSO_MESSAGE_UPLOAD.CREATE_MESSAGES');
    });

    if ($stateParams.decodedItsoMessages && $stateParams.decodedItsoMessages.length > 0) {
      this.decodedItsoMessages = $stateParams.decodedItsoMessages;
      this.paginatorData.totalCount = this.decodedItsoMessages.length;
      this.fetchCollection(1);
    }
  }

  /**
   * A method that adds a new decoded itso message to the list of decoded itso messages
   */
  public addDecodedItsoMessage = () => {
    const deferred = this.$q.defer();

    const newDecodedItsoMessage = {
      scheme: { link: '/schemes/' + this.userService.selectedScheme.id, abbreviation: this.userService.selectedScheme.reference },
      messageFields: {
        IPE_ISAMID: '12345',
        IPE_SAMSequenceNumber: '',
        TransactionDateTime: '',
        TransactionSequenceNumber: '',
        ITSO_SealerId: '',
        ITSO_Seq_Num: '',
        TripNumberOrTrainNumber: '',
        AmountPaid: '',
        Location: {
          LocationType: '',
          Origin: '',
          LocationFields: {
            ServiceNumber: '',
            BUS_STOP_CODE: null,
            ORIGIN_NLC: null
          }
        }
      }
    };

    this.dialogService.showDialog(
      this.$translate.instant('ITSO_MESSAGE_UPLOAD.ITSO_MESSAGE'),
      `decoded-itso-message-edit-dialog.html`,
      { decodedItsoMessage: newDecodedItsoMessage },
      'decoded-itso-message-edit-dialog'
    ).then((decodedItsoMessage: InterACT.Interfaces.ItsoMessages.DecodedItsoMessage) => {
      (<any>decodedItsoMessage).status = 'NOT_UPLOADED';

      if (decodedItsoMessage.messageFields.Location.LocationType === 'NAPTAN') {
        decodedItsoMessage.messageFields.Location.LocationFields.BUS_STOP_CODE = decodedItsoMessage.messageFields.Location.Origin;
        delete decodedItsoMessage.messageFields.Location.LocationFields.ORIGIN_NLC;
      } else {
        decodedItsoMessage.messageFields.Location.LocationFields.ORIGIN_NLC = decodedItsoMessage.messageFields.Location.Origin;
        decodedItsoMessage.messageFields.Location.LocationFields.BUS_STOP_CODE;
      }

      delete decodedItsoMessage.messageFields.Location.Origin;

      this.decodedItsoMessages.push(decodedItsoMessage);
      this.paginatorData.totalCount += 1;
      this.fetchCollection(this.paginatorData.currentPage);
      deferred.resolve();
    });

    return deferred.promise;
  }

  /**
   * A method that fetches a collection of decoded itso messages for the supplied page number
   * @param page The page number to get the list of decoded itso messages for
   */
  public fetchCollection = (page: number) => {
    const startIndex = (page - 1) * this.paginatorData.perPageCount;
    let endIndex = (startIndex + this.paginatorData.perPageCount) - 1;

    this.pagedDecodedItsoMessages = [];
    endIndex = endIndex > this.decodedItsoMessages.length - 1 ? this.decodedItsoMessages.length - 1 : endIndex;

    for (let c = startIndex; c <= endIndex; c++) {
      this.pagedDecodedItsoMessages.push(this.decodedItsoMessages[c]);
    }
  }

  /**
   * A method that provides the user with a means of editing a decoded itso message
   * @param decodedItsoMessageToEdit The decoded itso message to be edited
   */
  public editDecodedItsoMessage = (decodedItsoMessageToEdit: InterACT.Interfaces.ItsoMessages.DecodedItsoMessage) => {
    const deferred = this.$q.defer();

    this.dialogService.showDialog(
      this.$translate.instant('ITSO_MESSAGE_UPLOAD.ITSO_MESSAGE'),
      `decoded-itso-message-edit-dialog.html`,
      { decodedItsoMessage: decodedItsoMessageToEdit },
      'decoded-itso-message-edit-dialog'
    ).then((editedDecodedItsoMEssage) => {
      (<any>editedDecodedItsoMEssage).status = 'NOT_UPLOADED';
      const indexOfDecodedItsoMessage = this.decodedItsoMessages.indexOf(decodedItsoMessageToEdit);
      this.decodedItsoMessages[indexOfDecodedItsoMessage] = editedDecodedItsoMEssage;
      this.fetchCollection(this.paginatorData.currentPage);
      deferred.resolve();
    });

    return deferred.promise;
  }

  /**
   * A method that deletes the supplied decoded itso message
   * @param decodedItsoMessage The decoded itso message to be deleted
   */
  public deleteDecodedItsoMessage = (decodedItsoMessage: InterACT.Interfaces.ItsoMessages.DecodedItsoMessage) => {
    const indexOfDecodedItsoMessage = this.decodedItsoMessages.indexOf(decodedItsoMessage);

    if (indexOfDecodedItsoMessage === -1) {
      return;
    }

    this.decodedItsoMessages.splice(indexOfDecodedItsoMessage, 1);
    this.paginatorData.totalCount -= 1;
    this.fetchCollection(this.paginatorData.currentPage);
  }

  /**
   * A method that publishes the list of decoded itso messages into the system
   */
  public publish = () => {
    const deferred = this.$q.defer();
    const allPromises = [];

    this.$rootScope.showSpinner = true;
    for (let c = 0; c < this.decodedItsoMessages.length; c++) {
      if ((<any>this.decodedItsoMessages[c]).status !== 'COMPLETE') {
        allPromises.push(this.uploadDecodedItsoMessage(this.decodedItsoMessages[c]));
      }
    }

    this.$q.all(allPromises).then((results: Array<any>) => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('ITSO_MESSAGE_UPLOAD.MESSAGES_SUCCESSFULLY_CREATED');
      deferred.resolve();
    }).catch((error) => {
      this.$rootScope.showSpinner = false;
      deferred.reject();
    });

    return deferred.promise;
  };

  /**
   * calls the decoded itso message service to create the supplied decoded itso message on the server
   * @param decodedItsoMessage the decoded itso message to be uploaded / created
   * @returns a promise that resolves once the operation is complete
   */
  private uploadDecodedItsoMessage(decodedItsoMessage: InterACT.Interfaces.ItsoMessages.DecodedItsoMessage) {
    const copyOfDecodedItsoMessage = angular.copy(decodedItsoMessage);

    delete copyOfDecodedItsoMessage['$$hashKey'];
    delete copyOfDecodedItsoMessage['status'];
    delete copyOfDecodedItsoMessage['failureMessage'];

    this.appendHardCodedItsoFields(copyOfDecodedItsoMessage);

    (<any>decodedItsoMessage).status = 'UPLOADING';
    const promise = this.decodedItsoMessageService.create(copyOfDecodedItsoMessage);

    promise.then(() => {
      (<any>decodedItsoMessage).status = 'COMPLETE';
    }).catch((error) => {
      (<any>decodedItsoMessage).status = 'UPLOAD_FAILED';
      (<any>decodedItsoMessage).failureMessage = error.data.developerMessage;

    });

    return promise;
  }

  private appendHardCodedItsoFields(decodedItsoMessage: InterACT.Interfaces.ItsoMessages.DecodedItsoMessage) {
    decodedItsoMessage.itsoDTS = decodedItsoMessage.messageFields.TransactionDateTime;
    decodedItsoMessage.messageCode = '0209';
  }
}